import { Header, Text } from '@Components/Text';
import styled from 'styled-components';

export const ErrorText = styled(Text).attrs({
	weight: 'semi-bold',
	size: 'small',
})`
	color: #f1416c;
	margin-top: 0px;
	margin-bottom: 0px;
`;

export const ContainerRegister = styled.div`
	max-width: 500px !important;
	/* min-width: 500px !important; */
`;

export const LabelText = styled(Text).attrs({
	weight: 'extra-bold',
})`
	margin-bottom: 8px;
`;

export const SubTitle = styled(Header).attrs({
	variant: 'h5',
	weight: 'bold',
})`
	color: #7e8299;
`;

export const TextBtnSubmit = styled(SubTitle)`
	color: #ffffff;
	margin-bottom: 0px;
`;
